import { useMutation } from '@apollo/client';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import {
  MAC_POLICY_SET_ID,
  WINDOWS_POLICY_SET_ID
} from '@nile/banyan/src/Constants/policySet';
import {
  AVAILABLE_TRACY_ICON_OPTIONS,
  TRACY_ICON_ACTION_ITEMS
} from '@nile/banyan/src/Pages/Protected/Index/SystemTrayIconPageNew';
import {
  ActionGroup,
  DropdownIndicator,
  getTranslatedText,
  IndicatorSeparator,
  preFormatForm,
  validateForm,
  validateTrayIconName,
  validateTrayIconURL,
  VariableInput,
  validateTrayIconStaticText,
  validateTrayIconExecuteCommand,
  reactSelectInlineError,
  TEXT_LENGTH,
  getParsedCrudData
} from '@nile/components';
import { RMMClient, UPDATE_TRACY_ICON } from '@nile/graphql';
import { GET_ASSET_SCRIPT_LIST_V2 } from '@nile/rmm/src/modules/scripts/Graphql';
import {
  Heading,
  TextField,
  Label,
  Dropdown
} from '@superops/ui-design-system';
import dompurify from 'dompurify';
import produce from 'immer';
import { cloneDeep, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from 'react-select/creatable';
import styled from 'styled-components';
import { ModalContent, SrcInfoContainer } from '../Utils/style';
import { dompurifier } from '@nile/components/src/Utils/helpers';
const InfoContainer = styled(SrcInfoContainer)`
  align-items: center;
  padding: 20px 0;
  margin: 0;
  min-height: 80px;
  border-bottom: 1px solid #ececec;
  border-bottom-color: #ececec;
`;

const TaskContainer = styled.div`
  .mw-220 {
    max-width: 220px;
  }
  .captalize {
    text-transform: capitalize;
  }

  .mw-450 {
    max-width: 450px;
  }
`;

const EditorHolder = styled.div`
  #quill-rt-editor {
    height: 100%;
    padding: 17px 7px;
    border: 1px solid rgba(151, 151, 151, 0.3) !important;
    border-radius: 10px;

    .quill {
      min-height: 200px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
          padding-left: 10px !important;
          padding-right: 10px !important;
          &.ql-blank::before {
            left: 10px;
          }
        }
      }
    }
    .ql-toolbar {
      border: none;
      padding: 8px 23px !important;
    }
  }
`;

const defaultCondition = {
  listInfo: {
    view: { id: '1011' },
    condition: {
      joinOperator: 'AND',
      operands: [
        {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'scriptId',
              operator: 'isNotEmpty',
              value: ''
            }
          ]
        },
        {
          joinOperator: 'AND',
          operands: [
            {
              joinOperator: 'AND',
              operands: [
                {
                  value: 'LOGGED_IN_USER',
                  operator: 'is',
                  attribute: 'runAs'
                }
              ]
            }
          ]
        }
      ]
    }
  }
};

const SystemTrayMenuOptionForm = (props) => {
  const { intl, meta, sheetData, trayIconData, updateData } = props;
  const [menuData, setMenuData] = useState({});
  const [menuDataBase, setMenuDataBase] = useState({});

  const [menuType, setMenuType] = useState(sheetData?.menuData?.type);
  let [template, setTemplate] = useState({
    content: sheetData?.menuData?.aboutMessage
  });
  const [primaryLoading, setPrimaryLoading] = useState(false);
  const [scriptListWindows, setScriptListWindows] = useState([]);
  const [scriptListMac, setScriptListMac] = useState([]);
  const [newScripts, setNewScripts] = useState(true);
  const [errorObject, setErrorObject] = useState({});

  const updateTemplate = (data) => {
    setTemplate(data);
    const nextState = produce(menuData, (draft) => {
      draft['aboutMessage'] = dompurifier(data?.content);
    });
    setMenuData(nextState);
  };
  useEffect(() => {
    setMenuType(menuData?.type);
  }, [menuData.type]);

  function stopEvents(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const SelectableOptions = [];
  AVAILABLE_TRACY_ICON_OPTIONS.map((type) => {
    SelectableOptions.push({
      value: type,
      label: getTranslatedText(intl, TRACY_ICON_ACTION_ITEMS[type].label)
    });
  });

  const [updateSystemTrayIconMutation] = useMutation(UPDATE_TRACY_ICON, {
    client: RMMClient,
    onCompleted: (res) => {
      if (res && res.updateTrayIcon) {
        setPrimaryLoading(false);
        updateData(res.updateTrayIcon);
      }
    }
  });

  const getScriptsData = async (type) => {
    const { data: res } = await RMMClient.query({
      query: GET_ASSET_SCRIPT_LIST_V2,
      fetchPolicy: 'network-only',
      variables: { classId: type, ...defaultCondition }
    });
    const formatterData =
      res?.getAssetScriptListByClassId?.assetScripts?.map((script) => ({
        ...script,
        label: script.name,
        value: script.name
      })) || [];
    if (type === '1') {
      setScriptListWindows(formatterData);
    } else if (type === '3') {
      setScriptListMac(formatterData);
    }
  };

  //Filter other OS types if atleast one is selected
  const validateForScripts = (menuData) => {
    if (menuData.type === 'EXECUTE_SCRIPT') {
      const nextState = produce(menuData, (draft) => {
        let dataIndex = draft?.scripts?.findIndex((item) => {
          return item.script;
        });
        if (dataIndex !== -1)
          draft.scripts = draft?.scripts.filter(
            (item, index) => dataIndex === index
          );
      });
      return nextState;
    }
    return menuData;
  };

  const handleFormSave = () => {
    const validateTemplate = {
      URL: validateTrayIconURL,
      EXECUTE_SCRIPT: validateTrayIconExecuteCommand,
      STATIC_TEXT: validateTrayIconStaticText
    };
    const res = validateForm(
      preFormatForm(validateForScripts(menuData)),
      validateTemplate[menuType] || validateTrayIconName
    );
    if (!res) {
      let inputType =
        menuData && menuData.menuId
          ? { main: 'updateMenu' }
          : { main: 'addMenu' };

      const nextState = produce(menuData, (draft) => {
        if (menuType === 'EXECUTE_SCRIPT') {
          //Filter unfilled data
          draft.scripts = draft.scripts.filter((item) => {
            if (item.script) return item;
          });

          let { addedItems, updatedItems } = getParsedCrudData(
            menuDataBase.scripts || [],
            draft.scripts,
            'type'
          );

          if (!isEmpty(addedItems)) {
            draft['addScripts'] = addedItems;
          }
          if (!isEmpty(updatedItems)) {
            draft['updateScripts'] = updatedItems;
          }
        }
        delete draft.scripts;
      });

      setPrimaryLoading(true);
      updateSystemTrayIconMutation({
        variables: {
          iconId: trayIconData.iconId,
          input: {
            [inputType.main]: nextState
          }
        }
      });
    } else {
      setErrorObject(res);
    }
  };

  const onChangeText = (value, type) => {
    const nextState = produce(menuData, (draft) => {
      draft[type] = value;
    });
    setErrorObject({});
    setMenuData(nextState);
  };

  const onChangeScriptSelect = (
    { runTimeVars, scriptId, name, description },
    type
  ) => {
    const nextState = produce(menuData, (draft) => {
      if (!draft.scripts) draft.scripts = [];
      let index = draft.scripts.findIndex((item) => item.type === type);
      draft.scripts[index] = {
        type,
        arguments: runTimeVars,
        script: {
          description,
          name,
          scriptId
        }
      };
    });
    setErrorObject({});
    setMenuData(nextState);
  };

  const fetchScriptsOptionsData = () => {
    [MAC_POLICY_SET_ID, WINDOWS_POLICY_SET_ID].map((item) =>
      getScriptsData(item)
    );
  };

  const populateScriptData = () => {
    if (isEmpty(scriptListWindows) || isEmpty(scriptListMac)) {
      fetchScriptsOptionsData();
    }

    let data = cloneDeep(sheetData?.menuData);
    let savedScriptTypes = data?.scripts
      ? data?.scripts?.map((item) => item.type)
      : [];

    //Prefilling data since initial might not contain scripts
    //menuData's structure is essential for rendering UI
    data = {
      ...data,
      type: 'EXECUTE_SCRIPT'
    };

    if (isEmpty(savedScriptTypes)) {
      data['scripts'] = [
        {
          type: 'WINDOWS',
          arguments: []
        },
        {
          type: 'MAC',
          arguments: []
        }
      ];
    } else if (!savedScriptTypes.includes('WINDOWS')) {
      data.scripts = [
        ...data.scripts,
        {
          type: 'WINDOWS',
          arguments: []
        }
      ];
    } else if (!savedScriptTypes.includes('MAC')) {
      data.scripts = [
        ...data.scripts,
        {
          type: 'MAC',
          arguments: []
        }
      ];
    }
    //Maintaining a base state for computing added and updated scripts
    setMenuData(data);
    setMenuDataBase(sheetData?.menuData);
  };

  useEffect(() => {
    if (sheetData?.menuData?.type === 'EXECUTE_SCRIPT') {
      populateScriptData();
    } else {
      setMenuData(sheetData?.menuData);
    }
    () => {
      setMenuData({});
      setMenuDataBase({});
    };
  }, []);

  const handleVariableUpdate = (value, baseIndex, index) => {
    const nextState = produce(menuData, (draft) => {
      draft['scripts'][baseIndex]['arguments'][index]['value'] = value;
    });
    setMenuData(nextState);
  };

  const onFormtypeChange = ({ value }) => {
    //Handling on change when its script separately, since we need to populate scripts array
    if (value === 'EXECUTE_SCRIPT') {
      populateScriptData();
    } else {
      onChangeText(value, 'type');
    }
    setMenuType(value);
    setErrorObject({});
  };

  if (!menuType) {
    return <div>loading</div>;
  }
  return (
    <>
      <ModalContent
        onClick={stopEvents}
        style={{ width: '750px', padding: '0 40px 24px' }}
      >
        <div>
          <InfoContainer>
            <div className="fx2">
              <Heading element="h1">{meta.title}</Heading>
            </div>
            <div className="fx fx2 jend actr save-card " superid="taskBtns">
              <ActionGroup
                primaryText={<FormattedMessage id="common.save" />}
                primaryAction={handleFormSave}
                onlyPrimary
                primaryLoading={primaryLoading}
              />
            </div>
          </InfoContainer>
          <TaskContainer className="SOP-Task-Details mt-30">
            <div className="fx mb-20">
              <Heading element="h2">
                <FormattedMessage id="admin.system.menu.details" />
              </Heading>
            </div>
            <div className="mb-20 mw-450">
              <Label>
                <FormattedMessage id="admin.systemTrayIcon.menu.menuType.header" />
              </Label>
              <div superid="taskName  mw-450">
                <Dropdown
                  classNamePrefix="value_selector"
                  isDisabled={menuData?.menuId}
                  defaultValue={{
                    label: getTranslatedText(
                      intl,
                      TRACY_ICON_ACTION_ITEMS[menuType]?.label
                    ),
                    value: getTranslatedText(
                      intl,
                      TRACY_ICON_ACTION_ITEMS[menuType]?.label
                    )
                  }}
                  components={{
                    IndicatorSeparator,
                    DropdownIndicator
                  }}
                  name="team"
                  onChange={onFormtypeChange}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 })
                  }}
                  options={SelectableOptions}
                />
              </div>
            </div>
            <div className="mb-20 mw-450">
              <div superid="taskName">
                <TextField
                  requiredIndicator
                  label={getTranslatedText(
                    intl,
                    'admin.systemTrayIcon.menu.menuName.header'
                  )}
                  placeholder={getTranslatedText(
                    intl,
                    'admin.systemTrayIcon.menu.enterMenuName.pl'
                  )}
                  value={menuData?.name}
                  id="name"
                  className="name"
                  type="text"
                  onChange={(e) => onChangeText(e, 'name')}
                  error={errorObject?.['name']}
                  maxLength={TEXT_LENGTH.size_4}
                />
              </div>
            </div>
            <div className="mb-20 mw-450">
              <div superid="toolTipText">
                <TextField
                  label={getTranslatedText(
                    intl,
                    'admin.systemTrayIcon.menu.toolTipText.header'
                  )}
                  placeholder={getTranslatedText(
                    intl,
                    'admin.systemTrayIcon.menu.enterToolTip.pl'
                  )}
                  value={menuData?.toolTipText}
                  id="tooltip"
                  className="tooltip"
                  type="text"
                  onChange={(e) => onChangeText(e, 'toolTipText')}
                  error={errorObject?.['toolTipText']}
                  maxLength={TEXT_LENGTH.size_5}
                />
              </div>
            </div>

            {menuType === 'ABOUT' && (
              <div className="mb-20">
                <div className="mb-8 mr-10">
                  <Label>
                    <FormattedMessage id="admin.systemTrayIcon.menu.message.header" />
                  </Label>
                </div>
                <EditorHolder className="mb-10">
                  <EmailEditor
                    template={template}
                    updateTemplate={updateTemplate}
                    module="TICKET"
                    details={{ operation: 'CREATE' }}
                  />
                </EditorHolder>
              </div>
            )}
            {menuType === 'URL' && (
              <div className="mb-20">
                <div superid="urlName">
                  <TextField
                    value={menuData?.url}
                    id="name"
                    className="name"
                    placeholder="Enter URL"
                    label="URL"
                    type="text"
                    onChange={(e) => onChangeText(e, 'url')}
                    error={errorObject?.['url']}
                    maxLength={TEXT_LENGTH.size_6}
                  />
                </div>
              </div>
            )}
          </TaskContainer>
          {menuType === 'EXECUTE_SCRIPT' && (
            <TaskContainer className="SOP-Task-Details mt-40">
              <div className="fx mb-20">
                <Heading element="h3"> Menu details</Heading>
              </div>
              {menuData?.scripts?.map((baseItem, baseIndex) => {
                return (
                  <div className="mb-30">
                    <div className="mw-450">
                      <Label>{baseItem?.type?.toLowerCase()} Script</Label>
                      <Dropdown
                        defaultValue={{
                          value: baseItem?.script,
                          label: baseItem?.script?.name
                        }}
                        label={getTranslatedText(
                          intl,
                          'asset.runscript.script.select.label'
                        )}
                        options={
                          baseItem.type === 'WINDOWS'
                            ? scriptListWindows
                            : scriptListMac
                        }
                        onChange={(value) =>
                          onChangeScriptSelect(value, baseItem.type)
                        }
                        components={{ IndicatorSeparator, DropdownIndicator }}
                        classNamePrefix="value_selector"
                        menuPlacement="auto"
                        placeholder={getTranslatedText(
                          intl,
                          'asset.runscript.script.select.placeholder'
                        )}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (base) => ({ ...base, zIndex: 9999 })
                        }}
                        isSearchable
                      />
                    </div>
                    {errorObject?.scripts &&
                    errorObject?.scripts[0]?.errors[baseIndex]?.error?.script
                      ? reactSelectInlineError(
                          errorObject.scripts[0].errors[baseIndex].error
                            .script[0]
                        )
                      : ''}
                    {!!baseItem?.arguments?.length &&
                      baseItem?.arguments.map((variable, argumentsIndex) => {
                        return (
                          <VariableInput
                            error={
                              errorObject?.scripts &&
                              errorObject.scripts[0]?.errors[baseIndex]?.error
                                ?.arguments
                                ? errorObject.scripts[0]?.errors[baseIndex]
                                    ?.error?.arguments[0]?.errors[
                                    argumentsIndex
                                  ]?.error
                                : ''
                            }
                            intl={intl}
                            variable={variable}
                            index={argumentsIndex}
                            handleVariableUpdate={(argumentsIndex, value) =>
                              handleVariableUpdate(
                                value,
                                baseIndex,
                                argumentsIndex
                              )
                            }
                          />
                        );
                      })}
                  </div>
                );
              })}
            </TaskContainer>
          )}
        </div>
      </ModalContent>
    </>
  );
};

export default injectIntl(SystemTrayMenuOptionForm);
